import { handleAxiosErrorMessage } from '../../../../utils';
import { STAGE_ALREADY_EXISTS } from './leadApi.constants';

export function isStageAlreadyExistsError(error) {
  return handleAxiosErrorMessage(error) === STAGE_ALREADY_EXISTS;
}
